// extracted by mini-css-extract-plugin
export default {"item":"D367r7gQmQmi_x23WRjQ","subtitle":"_UbTpwZ9G5rK8w0Hhnp1","text":"i9MK0vo_DLzGZhUPRGgR"};